module.exports = __webpack_public_path__ + "img/49-bellboy.c58c820b.svg";